<template>
  <div class="container">
    <div class="row width_full">
      <div class="col_12">
        <div class="common_subtitle pb_20">
          <h3 class="mb_0">Sliders</h3>
          <button class="btn btn_success" style="float: right" @click="addNewSlider()">Add New Slider</button>
        </div>
        <template v-for="(slideType, index) in slidersTypes" :key="'slider_d'+index">
          <div :class="['row',{'mt_20 pt_20':index > 0}]" >
            <div class="col_12">
              <div class="common_subtitle pb_20">
                <h3 class="mb_0">{{ slideType.name }}</h3>
              </div>
            </div>
            <div class="col_12" v-if="sliders">
              <draggable
                  class="Item_sort"
                  tag="ul"
                  :list="sliders"
                  :group="{ name: 'g1' }"
                  item-key="name"
                  @sort="sortBanner(sliders, slideType.id)"
              >
                <template #item="{element}">
                  <li v-if="element.type === slideType.id">
                    <div class="slider_item p_relative">
                      <video v-if="element.file_type == 'video' "   controls>
                        <source :src="element.image" type="video/mp4">
                        Your browser does not support the video tag.
                      </video>

                      <img v-else :src="element.image ? element.image : '/assets/media/images/no-image.png'" alt="" class="banner_item">
                      <div class="banner_edit p_absolute">
                        <div class="cross_ic" @click.prevent="deleteFileSlider(element.id)">
                          <i class='bx bx-x'></i>
                        </div>
                        <div class="edit_ico" @click.prevent="editSlider(element)">
                          <i class='bx bx-edit'></i>
                        </div>
                      </div>
                    </div>
                  </li>
                </template>
              </draggable>
            </div>
          </div>
        </template>

        <br>
        <br>
        <br>
        <br>
      </div>

    </div>
  </div>
  <modal-component
      v-if="showModal"
      :modal-size="'custom_modal_800p'"
      :header-classes="'display_table white_bg no_border pa15 pb_0'"
      :content-classes="'pl_15 pr_15'"
      @closeModal="closeModal"
  >
    <template #header>
      <span class="modal_header_title">Add Banner</span>
    </template>
    <template #content>
      <div class="row">
        <div class="col_12">
          <div :class="['form-group', {'has_error': errorFor('name')}]">
            <label>name</label>
            <input type="text" class="form_global" placeholder="Name" v-model="form.name">
            <template v-if="errors && errors.name">
              <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.name" :key="'error_status_'+errorIndex">{{error}}</small>
            </template>
          </div>
          <div :class="['form-group', {'has_error': errorFor('link')}]">
            <label>Link</label>
            <input type="text" class="form_global" placeholder="Link" v-model="form.link">
            <template v-if="errors && errors.link">
              <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.link" :key="'error_status_'+errorIndex">{{error}}</small>
            </template>
          </div>
          <div :class="['form-group', {'has_error': errorFor('type')}]">
            <label>Banner Type</label>
            <select  class="form_global" v-model="form.type">
              <option value="">Select Type</option>
              <option v-for="page in slidersTypes" :key="'page'+page.id" :value="page.id">{{page.name}}</option>
            </select>
            <template v-if="errors && errors.parent">
              <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.parent" :key="'error_status_'+errorIndex">{{error}}</small>
            </template>
          </div>
          <div :class="['form-group', {'has_error': errorFor('image')}]">
            <label>Image</label>
            <input type="file" class="form_global" ref="imageInput" accept="image/png, image/gif, image/jpeg, video/mp4,video/x-m4v,video/*" @input="onFileChange($event)">
            <template v-if="errors && errors.image">
              <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.image" :key="'error_status_'+errorIndex">{{error}}</small>
            </template>
          </div>
          <div class="form-group" v-if="tempImage && tempType == 'image'">
            <div class="cross_ic" @click.prevent="deleteFile">
              <i class='bx bx-x'></i>
            </div>
            <img :src="tempImage" alt=""   width="150">
          </div>
          <div class="form-group" v-if="tempImage && tempType == 'video'">
            <div class="cross_ic" @click.prevent="deleteFile">
              <i class='bx bx-x'></i>
            </div>
            <video   width="150" :src="tempImage" controls>
              Your browser does not support the video tag.
            </video>
          </div>
          <div class="d_flex_end">
            <button class="btn btn_common" @click="submit()">Save</button>
          </div>
        </div>


      </div>
    </template>
  </modal-component>
</template>

<script>
import ModalComponent from "../../components/shared/ModalComponent";
import draggable from "vuedraggable"
export default {
  name: "MainSlider",
  components: {ModalComponent, draggable},
  data(){
    return {
      sliders: [],
      slidersTypes: [],
      smBanners: [],
      showModal:false,
      form:{
        name: '',
        type: 1,
        link: '',
        image: '',
      },
      tempImage: '',
      tempType: '',
      newForm: null,
    }
  },
  created() {
    this.loadData()
  },
  methods:{
    sortBanner(ids, type){
      this.axios.post('/sliders/sort', {sliders:ids, type:type})
          .then(() => {
            this.loadData();
            this.showSuccessMsg("Slider Sorted Successfully!");
          })
    },
    closeModal(){
      this.showModal = false
    },
    addNewSlider(){
      this.resetForm()
      this.deleteFile()
      this.newForm = true
      this.showModal = true
    },
    onFileChange(event){
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;

      let file = event.target.files[0]
      this.form.image = file

      let imageTypes = ['image/png', 'image/gif', 'image/jpeg']
      let videoTypes = ['video/mp4','video/x-m4v']

      if(imageTypes.includes(file.type)){
        this.tempType = 'image'
      }else if(videoTypes.includes(file.type)){
        this.tempType = 'video'
      }
      this.tempImage = URL.createObjectURL(file);
    },
    deleteFile(){
      this.tempImage = null
      this.tempType = null
      this.form.image = null
      if(this.$refs.imageInput)
        this.$refs.imageInput.value = null
    },
    loadData(){
      this.axios.get('/sliders')
          .then((response) => {
            this.sliders = response.data.data
          })
      this.axios.get('/sliders/types')
          .then((response) => {
            this.slidersTypes = response.data
          })
    },
    deleteFileSlider(id) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/sliders/'+id).then(() => {
            this.$swal.fire(
                'Deleted',
                'Slider has been deleted!',
                'success'
            )
            this.loadData();
          });
        }
      });
    },
    editSlider(row){
      this.resetForm()
      this.deleteFile()
      this.newForm = false
      this.form = {...row}
      this.showModal = true
    },
    submit() {
      this.errors = null;
      this.loading = true;

      let formData = new FormData()

      Object.keys(this.form).forEach(key => {
        formData.append(key, this.form[key] ? this.form[key] : '');
      })

      if (this.newForm) {
        this.axios.post('/sliders', formData)
            .then(() => {
              this.showModal = false;
              this.loadData();
              this.resetForm()
              this.deleteFile()
              this.showSuccessMsg("Added Successfully!");
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      } else {
        formData.append('_method','PATCH')

        this.axios.post('/sliders/'+ this.form.id, formData)
            .then(() => {
              this.showModal = false;
              this.loadData();
              this.deleteFile()
              this.showSuccessMsg("Updated Successfully!");
              this.resetForm()
            })
            .catch((err) => {
              this.errors = err.response.data.errors
            })
            .finally(() => {
              this.loading = false;
            })
      }

    },
    resetForm(){
      this.form = {
        file: '',
        type: 1,
        link: '',
        title: '',
        description: ''
      }
      this.newForm = false
      this.deleteFile()
    },
  }
}
</script>


<style scoped>
.cross_ic{
  position: absolute;
  z-index: 1;
  background: black;
  padding: 2px 2px 0px 2px;
  cursor: pointer;
  color: #fff;
}
.Item_sort{
  display: flex;
  width: 100%;
}
.Item_sort li{
  margin-right: 15px;
  width: 20%;
}
.Item_sort img{
  width: 100%;
  max-height: 180px;
}
.Item_sort video{
  width: 100%;
}
.Item_sort .slider_item{
  width: 100%;
  display: flex;
}
</style>